import React from 'react'
import styled from 'styled-components'
import { StreamData } from 'types/streamData'
import Title from '../Title'
import AuthorComponent from './AuthorComponent'
import DirectionContentComponent from '../DirectionContentComponent'
import { StyleAuthorContainer } from '../index.css'

const StyledTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`

type HeaderInfoProps = {
  streamData: StreamData
  fontSize?: number
}

const HeaderInfo = ({ streamData, fontSize }: HeaderInfoProps) => {
  const { title, isTitleRtl } = streamData

  return title ? (
    <DirectionContentComponent isRtl={isTitleRtl}>
      <StyledTitleContainer>
        <Title streamData={streamData} fontSize={fontSize} />
        <StyleAuthorContainer>
          <AuthorComponent streamData={streamData} />
        </StyleAuthorContainer>
      </StyledTitleContainer>
    </DirectionContentComponent>
  ) : (
    <AuthorComponent streamData={streamData} />
  )
}

export default HeaderInfo
